import { ReactNode } from "react";
import "./style.css";

interface ProductProps {
  header: string;
  image: string;
  children: ReactNode;
  direction: "left-right" | "right-left";
}

const Product = ({ header, image, children, direction }: ProductProps) => {
  return (
    <section className="d-flex container justify-content-center product-section-item">
      <div className={`mx-2 mx-lg-4`}>
        <img src={image} alt={header} className="product-section-image" />
      </div>
      <div
        className={`mx-2 mx-lg-4 d-flex justify-content-center align-items-center product-section-info ${
          direction === "right-left" ? "order-first" : ""
        }`}
      >
        <div>
          <h3 className="display-6 text-theme mt-5 fw-bold">{header}</h3>
          <div className="my-3 text-theme product-content-text">{children}</div>
        </div>
      </div>
    </section>
  );
};

export default Product;
